export function convertToFormUrlEncoded(
  jsonObject: Record<string, string | number | boolean> = {}
): string {
  const query = Object.keys(jsonObject)
    .map((key) => `${key}=${encodeURIComponent(jsonObject[key])}`)
    .join('&');

  return query;
}
